export var checkFolderHasBeenRemoved = function checkFolderHasBeenRemoved(oldList, newList) {
  for (var i = 0; i < oldList.length; i++) {
    var oldId = oldList[i];
    var idHasBeenRemoved = true;
    for (var j = 0; j < newList.length; j++) {
      var newId = newList[j];
      if (oldId === newId) {
        idHasBeenRemoved = false;
        break;
      }
    }
    if (idHasBeenRemoved) {
      return true;
    }
  }
  return false;
};